module.exports = __webpack_public_path__ + "media/images/icons/brands/sass-25ed8365e6969639418294917b0aa3ea.svg";